import { viewerApiUrl } from "API/urls/viewer.api";
import { axiosInstance } from "configs/axios";

export const taskCompletionStatusViewerApi = async (isViewer, docType) => {
  try {
    const response = await axiosInstance.post(viewerApiUrl.task, {
      isViewer,
      docType,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
